import { NewContactOutDto, NewContactInDto } from '../../../types/contact.dto'

export const NEW_CONTACT = 'NEW_CONTACT'
export const NEW_CONTACT_SUCCESS = 'NEW_CONTACT_SUCCESS'
export const NEW_CONTACT_ERROR = 'NEW_CONTACT_ERROR'
export const RESET_NEW_CONTACT = 'RESET_NEW_CONTACT'

export interface NewContact {
  type: typeof NEW_CONTACT
  payload: NewContactOutDto
}

export interface NewContactSuccess {
  type: typeof NEW_CONTACT_SUCCESS
  payload: NewContactInDto
}

export interface NewContactError {
  type: typeof NEW_CONTACT_ERROR
  payload: string | boolean
}

export interface ResetNewContact {
  type: typeof RESET_NEW_CONTACT
  payload: null
}

export interface State {
  data: NewContactInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = NewContact | NewContactSuccess | NewContactError | ResetNewContact
